module.exports = __webpack_public_path__ + "img/four.0a9cf585.svg";